<template>
  <v-container>
    <div class="mic_container">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="mic_form"
      >
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer"
        >
          <v-toolbar-title>Verlaufskontrolle</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-menu
                ref="trackingDateMenu"
                :close-on-content-click="false"
                v-model="trackingDateMenu"
                :nudge-right="40"
                :return-value.sync="trackingDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="computedDateFormatted"
                  label="Datum Verlaufskontrolle *"
                  persistent-hint
                  prepend-icon="event"
                  @blur="trackingDate = parseDate(trackingDateFormatted)"
                  :rules=trackingDateRules
                  required
                ></v-text-field>
                <v-date-picker v-model="trackingDate" no-title scrollable required>
                  <v-spacer></v-spacer>
                  <v-btn flat color="#5ba322" @click="trackingDateMenu = false">Cancel</v-btn>
                  <v-btn flat color="#5ba322" @click="$refs.trackingDateMenu.save(trackingDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-select
                v-model="trackingType"
                :items="trackingTypeItems"
                :rules="trackingTypeRules"
                label="Art der Verlaufskontrolle *"
                required
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer"
        >
          <v-toolbar-title>Allgemeines / Körpermaße</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <div>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ waistSizeHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-text-field
                v-model="waistSize"
                :rules="waistSizeRules"
                label="Taillenweite (in cm) *"
                :messages=waistSizeMessages
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ hipsSizeHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-text-field
                v-model="hipsSize"
                :rules="hipsSizeRules"
                label="Hüftweite (in cm)"
                :messages=hipsSizeMessages
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-text-field
                v-model="weight"
                :rules="weightRules"
                label="Gewicht (in kg) *"
                :messages=weightMessages
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-text-field
                v-model="height"
                :rules="heightRules"
                label="Größe (in cm) *"
                :messages=heightMessages
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ weeklyHoursMotionHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-text-field
                v-model="weeklyHoursMotion"
                :rules="weeklyHoursMotionRules"
                label="Stunden Bewegung pro Woche *"
                :messages=weeklyHoursMotionMessages
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ amountOfFoodHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="amountOfFood"
                :items="amountOfFoodItems"
                :rules="amountOfFoodRules"
                label="Nahrungsmenge"
                :messages=amountOfFoodMessages
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-radio-group
                v-model="snacks"
                :messages=snacksMessages
                :rules="snacksRules"
                label="Zwischensnacks zwischen oder nach den drei Hauptmahlzeiten">
                <v-radio label="Ja" :value=true></v-radio>
                <v-radio label="Nein" :value=false></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div class="v-text-field__details">
            <div class="v-messages theme--light">
              <div class="v-messages__wrapper">
                <div class="v-messages__message">
                  {{ bloodPressureHint }}
                </div>
              </div>
            </div>
          </div>
          <v-layout>
            <v-flex
              xs12
              md2
            >
              <v-text-field
                class="mic_double-item-input-row"
                v-model="bloodPressure.systolic.value"
                :rules="bloodPressure.systolic.rules"
                label="Blutdruck"
                :messages=bloodPressureMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2>
              <v-text-field
                class="mic_double-item-input-row"
                v-model="bloodPressure.diastolic.value"
                :rules="bloodPressure.diastolic.rules"
                label="zu"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2>
              <v-select
                v-model="bloodPressure.posture"
                :items=bloodPressure.postureItems
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ physicalAbilityHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="physicalAbility"
                :items="physicalAbilityItems"
                :rules="physicalAbilityRules"
                label="Körperliche Leistungsfähigkeit *"
                :messages=physicalAbilityMessages
                required
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ wellBeingHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="wellBeing"
                :items="wellBeingItems"
                :rules="wellBeingRules"
                label="Wohlbefinden / Lebensqualität  *"
                :messages=wellBeingMessages
                required
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ objectiveAchievementHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="objectiveAchievement"
                :items="objectiveAchievementItems"
                :rules="objectiveAchievementRules"
                label="Ziele zu erreichen"
                :messages=objectiveAchievementMessages
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ easyOfConversionHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="easyOfConversion"
                :items="easyOfConversionItems"
                :rules="easyOfConversionRules"
                label="Wie leicht (Bitte erst bei 2. und 3. Verlaufskontrolle ausfüllen)"
                :messages=easyOfConversionMessages
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ benefitHint }}
                    </div>
                  </div>
                </div>
              </div>
              <v-select
                v-model="benefit"
                :items="benefitItems"
                :rules="benefitRules"
                label="Wie vorteilhaft (Bitte erst bei 2. und 3. Verlaufskontrolle ausfüllen)"
                :messages=benefitMessages
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-toolbar
          card
          color="#5ba322"
          dark
          class="mic_form-spacer"
        >
          <v-toolbar-title>Blutzucker (bitte nüchtern in der Apotheke bestimmen lassen, bzw. selbst messen)
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="mic_form-content">
          <v-layout>
            <v-flex
              xs12
              md6>
              <div>
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ bloodsugarHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="bloodsugar"
                v-model="bloodsugar"
                :rules="bloodsugarRules"
                label="Blutzucker"
                :messages=bloodsugarMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="bloodsugarUnit"
                :items="bloodsugarUnitItmes"
                :rules="bloodsugarUnitRules"
                :messages=bloodsugarUnitMessages
                @change="validate('bloodsugar')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <v-subheader class="mic_subheader">
                Falls kürzlich vom Hausarzt Blutwerte bestimmt worden sind, bitte jetzt auch Folgendes angeben mitsamt
                den richtigen Einheiten:
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ longtermSugarHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="longtermSugar"
                v-model="longtermSugar"
                :rules="longtermSugarRules"
                label="Langzeitzucker"
                :messages=longtermSugarMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="longtermSugarUnit"
                :items="longtermSugarUnitItmes"
                :rules="longtermSugarUnitRules"
                :messages=longtermSugarUnitMessages
                @change="validate('longtermSugar')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ triglyceridesHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="triglycerides"
                v-model="triglycerides"
                :rules="triglyceridesRules"
                label="Triglyzeride"
                :messages=triglyceridesMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="triglyceridesUnit"
                :items="triglyceridesUnitItmes"
                :rules="triglyceridesUnitRules"
                :messages=triglyceridesUnitMessages
                @change="validate('triglycerides')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ cholesterolHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="cholesterin"
                v-model="cholesterol"
                :rules="cholesterolRules"
                label="Cholesterin"
                :messages=cholesterolMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="cholesterolUnit"
                :items="cholesterolUnitItmes"
                :rules="cholesterolUnitRules"
                :messages=cholesterolUnitMessages
                @change="validate('cholesterin')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ hdlCholesterolHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="hdl"
                v-model="hdlCholesterol"
                :rules="hdlCholesterolRules"
                label="HDL"
                :messages=hdlCholesterolMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="hdlCholesterolUnit"
                :items="hdlCholesterolUnitItmes"
                :rules="hdlCholesterolUnitRules"
                :messages=hdlCholesterolUnitMessages
                @change="validate('hdl')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ ldlCholesterolHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="ldl"
                v-model="ldlCholesterol"
                :rules="ldlCholesterolRules"
                label="LDL"
                :messages=ldlCholesterolMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="ldlCholesterolUnit"
                :items="ldlCholesterolUnitItmes"
                :rules="ldlCholesterolUnitRules"
                :messages=ldlCholesterolUnitMessages
                @change="validate('ldl')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ gptAltAlatHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="gpt"
                v-model="gptAltAlat"
                :rules="gptAltAlatRules"
                label="GPT (bzw. ALT oder ALAT)"
                :messages=gptAltAlatMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="gptAltAlatUnit"
                :items="gptAltAlatUnitItmes"
                :rules="gptAltAlatUnitRules"
                :messages=gptAltAlatUnitMessages
                @change="validate('gpt')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ gotAstAsatHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="got"
                v-model="gotAstAsat"
                :rules="gotAstAsatRules"
                label="GOT (bzw. AST oder ASAT)"
                :messages=gotAstAsatMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="gotAstAsatUnit"
                :items="gotAstAsatUnitItmes"
                :rules="gotAstAsatUnitRules"
                :messages=gotAstAsatUnitMessages
                @change="validate('got')"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md6>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ ygtGgetGammaGTHint }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md5
            >
              <v-text-field
                class="mic_double-item-input-row"
                name="ygt"
                v-model="ygtGgetGammaGT"
                :rules="ygtGgetGammaGTRules"
                label="yGT (bzw. GGT oder Gamma-GT)"
                :messages=ygtGgetGammaGTMessages
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md1>
              <v-select
                v-model="ygtGgetGammaGTUnit"
                :items="ygtGgetGammaGTUnitItmes"
                :rules="ygtGgetGammaGTUnitRules"
                :messages=ygtGgetGammaGTUnitMessages
                @change="validate('ygt')"
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <div class="mic_form-content">
          <v-btn color="#f5a900" @click="save" class="white--text ">Speichern</v-btn>
          <v-btn color="#f5a900" @click="back" class="white--text">zurück zur Übersicht</v-btn>
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      trackingDateMenu: false,
      trackingDate: new Date().toISOString().substr(0, 10),
      trackingDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      trackingDateRules: [
        v => !!v || 'Datum Verlaufskontrolle ist ein Pflichtfeld'
      ],
      trackingType: null,
      trackingTypeItems: [
        'vor Kostumstellung',
        'Verlaufskontrolle nach 3 Wochen',
        'Verlaufskontrolle nach 6 Wochen',
        'Verlaufskontrolle nach mehr 6 Wochen'
      ],
      trackingTypeRules: [
        v => !!v || 'Art des Verlaufskontrolle ist ein Pflichtfeld'
      ],
      waistSize: '',
      waistSizeMessages: [],
      waistSizeHint: 'Parallel zum Boden zwischen Rippen und Hüftknochen ca. am Bauchnabel messen. Wenn kein Maßband vorhanden ist, mit einer Schnur messen, die Länge markieren und dann an einem Zollstock abmessen.',
      waistSizeRules: [
        v => !!v || 'Taillenweite ist ein Pflichtfeld',
        v => v.replace(',', '.') >= 40 || 'Taillenweite muss größer als 40 cm sein.',
        v => v.replace(',', '.') <= 140 || 'Taillenweite muss kleiner als 140 cm sein.'
      ],
      hipsSize: '',
      hipsSizeHint: 'Parallel zum Boden da messen, wo der Po am dicksten ist.',
      hipsSizeMessages: [],
      hipsSizeRules: [
        v => (v === '' || v.replace(',', '.') >= 80) || 'Hüftweite muss größer als 80 cm sein.',
        v => (v === '' || v.replace(',', '.') <= 180) || 'Hüftweite muss kleiner als 180 cm sein.'
      ],
      weight: '',
      weightMessages: [],
      weightRules: [
        v => !!v || 'Gewicht ist ein Pflichtfeld',
        v => v.replace(',', '.') >= 40 || 'Gewicht muss größer als 40 kg sein.',
        v => v.replace(',', '.') <= 200 || 'Gewicht muss kleiner als 200 kg sein.'
      ],
      height: '',
      heightMessages: [],
      heightRules: [
        v => !!v || 'Größe Verlaufskontrolle ist ein Pflichtfeld',
        v => v.replace(',', '.') >= 140 || 'Größe muss größer als 140 cm sein.',
        v => v.replace(',', '.') <= 220 || 'Größe muss kleiner als 220 cm sein.'
      ],
      weeklyHoursMotion: '',
      weeklyHoursMotionHint: 'Wie viele Stunden sportliche Bewegung pro Woche (für Senioren zählen auch schwere Haus- und Gartenarbeit oder ein flotter Spaziergang)',
      weeklyHoursMotionMessages: [],
      weeklyHoursMotionRules: [
        v => !!v || 'Stunden Bewegung pro Woche ist ein Pflichtfeld',
        v => v.replace(',', '.') >= 0 || 'Stunden Bewegung pro Woche muss mindestens 0 Std sein.',
        v => v.replace(',', '.') <= 40 || 'Stunden Bewegung pro Woche darf maximal 40 Std sein.'
      ],
      amountOfFood: '',
      amountOfFoodHint: 'Beurteilung der eigenen Nahrungsmenge Skala von 1(sehr wenig) bis 10 (sehr viel)',
      amountOfFoodMessages: [],
      amountOfFoodRules: [],
      amountOfFoodItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      snacks: null,
      snacksMessages: [],
      snacksHint: '',
      snacksRules: [],
      bloodPressure: {
        systolic: {
          value: '',
          unit: 'mmHg',
          rules: [
            v => (v === '' || v.replace(',', '.') >= 90) || 'Blutdruck Systolic muss mindestens 90 sein.',
            v => (v === '' || v.replace(',', '.') <= 230) || 'Blutdruck Systolic darf maximal 230 sein.'
            // v => (v === '' || parseInt(v) > parseInt(this.bloodPressure.diastolic.value)) || 'Blutdruck Systolic muss größer als Blutdruck Dialostic sein.'
          ]
        },
        diastolic: {
          value: '',
          unit: 'mmHg',
          rules: [
            v => (v === '' || v.replace(',', '.') >= 50) || 'Blutdruck Diastolic muss mindestens 50 sein.',
            v => (v === '' || v.replace(',', '.') <= 130) || 'Blutdruck Diastolic darf maximal 130 sein.',
            v => (v === '' || parseInt(v) < parseInt(this.bloodPressure.systolic.value)) || 'Blutdruck Dialostic muss kleiner als Blutdruck Systolic sein.'
          ]
        },
        posture: '',
        postureItems: ['im Stehen', 'im Sitzen']
      },
      bloodPressureRules: [],
      bloodPressureHint: 'Blutdruck (ev. aus der Apotheke) im Sitzen oder im Stehen',
      bloodPressureMessages: [],
      physicalAbility: '',
      physicalAbilityHint: 'Wie beurteilen Sie Ihre körperliche Leistungsfähigkeit in einer Skala von 1 (äußerst gering) bis 10 (äußerst hoch)',
      physicalAbilityMessages: [],
      physicalAbilityRules: [
        v => !!v || 'Körperliche Leistungsfähigkeit ist ein Pflichtfeld'
      ],
      physicalAbilityItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      wellBeing: '',
      wellBeingHint: 'Wie beurteilen Sie Ihr Wohlbefinden/Lebensqualität in einer Skala  1 (äußerst gering) – 10 (äußerst gut)',
      wellBeingMessages: [],
      wellBeingRules: [
        v => !!v || 'Wohlbefinden/Lebensqualität ist ein Pflichtfeld'
      ],
      wellBeingItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      objectiveAchievement: '',
      objectiveAchievementHint: 'Wie beurteilen Sie Ihre Fähigkeit, generell  Ziele zu erreichen, in einer Skala  1 (äußerst gering) – 10 (äußerst gut)',
      objectiveAchievementMessages: [],
      objectiveAchievementRules: [],
      objectiveAchievementItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      easyOfConversion: '',
      easyOfConversionMessages: [],
      easyOfConversionHint: 'Wie leicht war die Umstellung auf Low-Carb für Sie in einer Skala von 1 (äußerst schwierig) bis 10 (äußerst leicht)',
      easyOfConversionRules: [],
      easyOfConversionItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      benefit: '',
      benefitMessages: [],
      benefitHint: 'Wie vorteilhaft war die Umstellung auf Low-Carb für Sie in einer Skala von 1 (äußerst gering) bis 10 (äußerst hoch)',
      benefitRules: [],
      benefitItems: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
      ],
      bloodsugar: '',
      bloodsugarRules: [
        v => (v === '' || (this.bloodsugarUnit === 'mg/dl' ? v.replace(',', '.') >= 70 : v.replace(',', '.') * 18 >= 70)) || 'Blutzucker muss mindestens 70 mg/dl (~ 3,9 mmol/l) sein.',
        v => (v === '' || (this.bloodsugarUnit === 'mg/dl' ? v.replace(',', '.') <= 240 : v.replace(',', '.') * 18 <= 240)) || 'Blutzucker darf maximal 240 mg/dl (~ 13 mmol/l) sein.'
      ],
      bloodsugarMessages: [],
      bloodsugarHint: 'Nüchtern (in mg/dl z.B. 119 mg/dl oder in mmol/l z.B. 6,6 mmol/l)',
      bloodsugarUnit: 'mg/dl',
      bloodsugarUnitItmes: [
        'mg/dl',
        'mmol/l'
      ],
      bloodsugarUnitRules: [],
      bloodsugarUnitMessages: [],
      longtermSugar: '',
      longtermSugarRules: [
        v => (v === '' || (this.longtermSugarUnit === '%' ? v.replace(',', '.') >= 5 : ((v.replace(',', '.') / 10.929) + 2.15) >= 5)) || 'Langzeitzucker muss mindestens 5 % (~ 31,2 mmol/mol) sein.',
        v => (v === '' || (this.longtermSugarUnit === '%' ? v.replace(',', '.') <= 15 : ((v.replace(',', '.') / 10.929) + 2.15) <= 15)) || 'Langzeitzucker darf maximal 15 % (~ 140,4 mmol/mol) sein.'
      ],
      longtermSugarMessages: [],
      longtermSugarHint: 'wird manchmal als HbA1c angegeben (in % z.B. 6,1 % oder in mmol/mol z.B. 43 mmol/mol)',
      longtermSugarUnit: '%',
      longtermSugarUnitItmes: [
        '%',
        'mmol/mol'
      ],
      longtermSugarUnitRules: [],
      longtermSugarUnitMessages: [],
      triglycerides: '',
      triglyceridesRules: [
        v => (v === '' || (this.triglyceridesUnit === 'mg/dl' ? v.replace(',', '.') >= 50 : v.replace(',', '.') >= 0.57)) || 'Triglyzeride muss mindestens 50 mg/dl (~ 0,57 mmol/l) sein.',
        v => (v === '' || (this.triglyceridesUnit === 'mg/dl' ? v.replace(',', '.') <= 300 : v.replace(',', '.') <= 3.4)) || 'Triglyzeride darf maximal 300 mg/dl (~ 3,4 mmol/l) sein.'
      ],
      triglyceridesMessages: [],
      triglyceridesHint: 'wird manchmal als TG abgekürzt (in mg/dl z.B. 150 mg/dl oder in mmol/l z.B. 1,7 mmol/l)',
      triglyceridesUnit: 'mg/dl',
      triglyceridesUnitItmes: [
        'mg/dl',
        'mmol/l'
      ],
      triglyceridesUnitRules: [],
      triglyceridesUnitMessages: [],
      cholesterol: '',
      cholesterolRules: [
        v => (v === '' || (this.cholesterolUnit === 'mg/dl' ? v.replace(',', '.') >= 40 : v.replace(',', '.') >= 1.04)) || 'Cholesterin muss mindestens 40 mg/dl (~ 1,04 mmol/l) sein.',
        v => (v === '' || (this.cholesterolUnit === 'mg/dl' ? v.replace(',', '.') <= 400 : v.replace(',', '.') <= 10.4)) || 'Cholesterin darf maximal 400 mg/dl (~ 10,4 mmol/l) sein.'
      ],
      cholesterolMessages: [],
      cholesterolHint: 'wird manchmal als Gesamtcholesterin angegeben (in mg/dl z.B. 220 mg/dl oder in mmol/l z.B. 5,61 mmol/l)',
      cholesterolUnit: 'mg/dl',
      cholesterolUnitItmes: [
        'mg/dl',
        'mmol/l'
      ],
      cholesterolUnitRules: [],
      cholesterolUnitMessages: [],
      hdlCholesterol: '',
      hdlCholesterolRules: [
        v => (v === '' || (this.hdlCholesterolUnit === 'mg/dl' ? v.replace(',', '.') >= 20 : v.replace(',', '.') >= 0.52)) || 'HDL muss mindestens 20 mg/dl (~ 0,52 mmol/l) sein.',
        v => (v === '' || (this.hdlCholesterolUnit === 'mg/dl' ? v.replace(',', '.') <= 130 : v.replace(',', '.') <= 3.38)) || 'HDL darf maximal 130 mg/dl (~ 3,38 mmol/l) sein.'
      ],
      hdlCholesterolMessages: [],
      hdlCholesterolHint: 'wird manchmal als HDL-Cholesterin angegeben (in mg/dl 50 mg/dl oder in mmol/l) z.B. 1,3 mmol/l)',
      hdlCholesterolUnit: 'mg/dl',
      hdlCholesterolUnitItmes: [
        'mg/dl',
        'mmol/l'
      ],
      hdlCholesterolUnitRules: [],
      hdlCholesterolUnitMessages: [],
      ldlCholesterol: '',
      ldlCholesterolRules: [
        v => (v === '' || (this.ldlCholesterolUnit === 'mg/dl' ? v.replace(',', '.') >= 20 : v.replace(',', '.') >= 0.52)) || 'LDL muss mindestens 20 mg/dl (~ 0,52 mmol/l) sein.',
        v => (v === '' || (this.ldlCholesterolUnit === 'mg/dl' ? v.replace(',', '.') <= 400 : v.replace(',', '.') <= 10.4)) || 'LDL darf maximal 400 mg/dl (~ 10,4 mmol/l) sein.'
      ],
      ldlCholesterolMessages: [],
      ldlCholesterolHint: 'wird manchmal als LDL Cholesterin angegeben (in mg/dl 168 mg/dl oder in mmol/l) z.B. 4,3 mmol/l)',
      ldlCholesterolUnit: 'mg/dl',
      ldlCholesterolUnitItmes: [
        'mg/dl',
        'mmol/l'
      ],
      ldlCholesterolUnitRules: [],
      ldlCholesterolUnitMessages: [],
      gptAltAlat: '',
      gptAltAlatRules: [
        v => (v === '' || v.replace(',', '.') >= 10) || 'GPT muss mindestens 10 U/l sein.',
        v => (v === '' || v.replace(',', '.') <= 400) || 'GPT darf maximal 400 U/l sein.'
      ],
      gptAltAlatMessages: [],
      gptAltAlatHint: 'in U/l z.B. 40 U/l',
      gptAltAlatUnit: 'U/l',
      gptAltAlatUnitItmes: [
        'U/l'
      ],
      gptAltAlatUnitRules: [],
      gptAltAlatUnitMessages: [],
      gotAstAsat: '',
      gotAstAsatRules: [
        v => (v === '' || v.replace(',', '.') >= 10) || 'GOT muss mindestens 10 U/l sein.',
        v => (v === '' || v.replace(',', '.') <= 400) || 'GOT darf maximal 400 U/l sein.'
      ],
      gotAstAsatMessages: [],
      gotAstAsatHint: 'in U/l z.B. 40 U/l',
      gotAstAsatUnit: 'U/l',
      gotAstAsatUnitItmes: [
        'U/l'
      ],
      gotAstAsatUnitRules: [],
      gotAstAsatUnitMessages: [],
      ygtGgetGammaGT: '',
      ygtGgetGammaGTRules: [
        v => (v === '' || v.replace(',', '.') >= 10) || 'yGT muss mindestens 10 U/l sein.',
        v => (v === '' || v.replace(',', '.') <= 400) || 'yGT darf maximal 400 U/l sein.'
      ],
      ygtGgetGammaGTMessages: [],
      ygtGgetGammaGTUnit: 'U/l',
      ygtGgetGammaGTUnitItmes: [
        'U/l'
      ],
      ygtGgetGammaGTUnitRules: [],
      ygtGgetGammaGTUnitMessages: [],
      ygtGgetGammaGTHint: 'in U/l z.B. 40 U/l'
    }
  },
  beforeMount () {
    let tracking = JSON.parse(localStorage.getItem('previewTrackingData'))
    if (tracking) {
      this.trackingDate = tracking.trackingDay
      this.trackingType = tracking.trackingType
      this.waistSize = tracking.waistSize.value.replace('.', ',')
      this.hipsSize = tracking.hipsSize.value.replace('.', ',')
      this.weight = tracking.weight.value.replace('.', ',')
      this.height = tracking.height.value.replace('.', ',')
      this.weeklyHoursMotion = tracking.weeklyHoursMotion.value.replace('.', ',')
      this.amountOfFood = tracking.amountOfFood
      this.snacks = tracking.snacks
      this.bloodPressure.systolic.value = tracking.bloodPressure.systolic.value.replace('.', ',')
      this.bloodPressure.diastolic.value = tracking.bloodPressure.diastolic.value.replace('.', ',')
      this.bloodPressure.posture = tracking.bloodPressure.posture
      this.physicalAbility = tracking.physicalAbility
      this.wellBeing = tracking.wellBeing
      this.objectiveAchievement = tracking.objectiveAchievement
      this.easyOfConversion = tracking.easyOfConversion
      this.benefit = tracking.benefit
      this.bloodsugar = tracking.bloodsugar.value.replace('.', ',')
      this.bloodsugarUnit = tracking.bloodsugar.unit
      this.longtermSugar = tracking.longtermSugar.value.replace('.', ',')
      this.longtermSugarUnit = tracking.longtermSugar.unit
      this.triglycerides = tracking.triglycerides.value.replace('.', ',')
      this.triglyceridesUnit = tracking.triglycerides.unit
      this.cholesterol = tracking.cholesterol.value.replace('.', ',')
      this.cholesterolUnit = tracking.cholesterol.unit
      this.hdlCholesterol = tracking.hdlCholesterol.value.replace('.', ',')
      this.hdlCholesterolUnit = tracking.hdlCholesterol.unit
      this.ldlCholesterol = tracking.ldlCholesterol.value.replace('.', ',')
      this.ldlCholesterolUnit = tracking.ldlCholesterol.unit
      this.gptAltAlat = tracking.gptAltAlat.value.replace('.', ',')
      this.gptAltAlatUnit = tracking.gptAltAlat.unit
      this.gotAstAsat = tracking.gotAstAsat.value.replace('.', ',')
      this.gotAstAsatUnit = tracking.gotAstAsat.unit
      this.ygtGgetGammaGT = tracking.ygtGgetGammaGT.value.replace('.', ',')
      this.ygtGgetGammaGTUnit = tracking.ygtGgetGammaGT.unit
      localStorage.removeItem('previewTrackingData')
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.trackingDate)
    }
  },
  watch: {
    date (val) {
      this.trackingDateFormatted = this.formatDate(this.trackingDate)
    }
  },
  methods: {
    validate (field) {
      this.$refs.form.validate(field)
    },
    back () {
      this.$router.push('/tracking/overview')
    },
    save () {
      const {dispatch} = this.$store
      if (this.$refs.form.validate()) {
        let tracking = {
          trackingDay: this.trackingDate,
          trackingType: this.trackingType,
          waistSize: {
            value: this.waistSize.replace('.', ',')
          },
          hipsSize: {
            value: this.hipsSize.replace('.', ',')
          },
          weight: {
            value: this.weight.replace('.', ',')
          },
          height: {
            value: this.height.replace('.', ',')
          },
          weeklyHoursMotion: {
            value: this.weeklyHoursMotion.replace('.', ',')
          },
          amountOfFood: this.amountOfFood,
          snacks: this.snacks,
          bloodPressure: this.bloodPressure,
          physicalAbility: this.physicalAbility,
          wellBeing: this.wellBeing,
          objectiveAchievement: this.objectiveAchievement,
          easyOfConversion: this.easyOfConversion,
          benefit: this.benefit,
          bloodsugar: {
            value: this.bloodsugar.replace('.', ','),
            unit: this.bloodsugarUnit
          },
          longtermSugar: {
            value: this.longtermSugar.replace('.', ','),
            unit: this.longtermSugarUnit
          },
          triglycerides: {
            value: this.triglycerides.replace('.', ','),
            unit: this.triglyceridesUnit
          },
          cholesterol: {
            value: this.cholesterol.replace('.', ','),
            unit: this.cholesterolUnit
          },
          hdlCholesterol: {
            value: this.hdlCholesterol.replace('.', ','),
            unit: this.hdlCholesterolUnit
          },
          ldlCholesterol: {
            value: this.ldlCholesterol.replace('.', ','),
            unit: this.ldlCholesterolUnit
          },
          gptAltAlat: {
            value: this.gptAltAlat.replace('.', ','),
            unit: this.gptAltAlatUnit
          },
          gotAstAsat: {
            value: this.gotAstAsat.replace('.', ','),
            unit: this.gotAstAsatUnit
          },
          ygtGgetGammaGT: {
            value: this.ygtGgetGammaGT.replace('.', ','),
            unit: this.ygtGgetGammaGTUnit
          },
          userId: JSON.parse(localStorage.getItem('user')).id
        }

        localStorage.setItem('previewTrackingData', JSON.stringify(tracking))
        this.$router.push('/tracking/preview')
      } else {
        dispatch('alert/error', 'Dateneingabe nicht korrekt, bitte überprüfen Sie Ihre angegebenen Daten.', {root: true})
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>

<style scoped="true">
/*.v-text-field {*/
/*margin-top: 20px!important;*/
/*}*/
.v-input--radio-group {
  margin-top: 40px !important;
}

.mic_subheader {
  margin-top: 50px;
}

.mic_double-item-input-row {
  padding-right: 25px;
}

.mic_button_spacer {
  margin-top: 25px;
}

.v-text-field__details {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/tracking/TrackingPage.vue